"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZugentlastungValidator = void 0;
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
class ZugentlastungValidator {
}
exports.ZugentlastungValidator = ZugentlastungValidator;
ZugentlastungValidator.breiteMin = echain_shared_quantities_1.Q.Length.mm(1);
ZugentlastungValidator.breiteMax = echain_shared_quantities_1.Q.Length.mm(2000);
//# sourceMappingURL=ZugentlastungValidator.js.map